import React from "react";
import TransitionalHeader from "../components/TransitionalHeader";
import GenerosManifestoContent from "../components/GenerosManifestoContent";

const DOCS_URI =
  process.env.REACT_APP_GENEROS_DOCS_URI || "https://docs.generos.io";

function TransitionalManifesto() {
  return (
    <div className="flex flex-col min-h-screen overflow-hidden">
      <TransitionalHeader />
      <main className="grow pt-24 md:pt-28">
        <GenerosManifestoContent showTopBorder={false} />
        <section className="pb-20 md:pb-28">
          <div className="max-w-3xl mx-auto px-4 sm:px-6 text-center">
            <a
              href={DOCS_URI}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center font-extrabold rounded-lg px-8 py-3 text-xl bg-purple-600 hover:bg-purple-700 text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-1 focus-visible:ring-offset-2 focus-visible:ring-offset-primary-6 transition-colors"
            >
              Read Thesis
            </a>
          </div>
        </section>
      </main>
    </div>
  );
}

export default TransitionalManifesto;
